export default __webpack_public_path__ + "static/media/1478.efcf5627.png";